import React, { useState, useEffect } from "react";
import { Clock, Lock, ArrowRight, Plane, User, CreditCard, CheckCircle, CircleX } from "lucide-react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-hot-toast';
import {
  fetchBookingDetails, getcouponlist, validatecoupons, doBookingProcess, selectBookingDetails, selectBookingDetailsStatus, resetBookingDetails
} from "./flightSlice";
import { selectCurrentUser } from "../auth/authSlice";
import ItineraryLoader from "../../components/ItineraryLoader";
import FareSummary from "./FareSummary";
import Moment from 'moment';
import CurFt from "../../components/CurFt";
import { Dialog } from "@headlessui/react";
import { TruncatedTextHTML } from "../../components/TruncatedText"

import {
  initiateEasebuzzPaymentThunk,
  handleEasebuzzResponse,
  // verifyEasebuzzPayment,
  clearError,
  // resetPayment
} from '../payment/paymentSlice';
// import {
//   DoWalletTopUp,
//   clearWalletError,
// } from '../wallet/walletSlice';

import { openEasebuzzPaymentModal } from "../../services/easebuzzServiceNew";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import WalletUtils from "../../utils/walletUtils";
import { encryptAES } from "../../utils/crypto"
import { getapiKey, getdomainFullURL, getcrmbaseURL } from "../../api/axios";
import { usePaymentProcessRecharge } from "../../services/usePaymentProcessRecharge";

// import {
//   validateFare,
// } from "./flightSlice";
export default function Review() {
  useDocumentTitle('Flight Review');
  const { BookingID } = useParams()
  const dispatch = useDispatch();
  const { paymentInitiated, paymentStatus, paymentData } = useSelector((state) => state.payment);
  const { walletpaymentInitiated, walletpaymentStatus, walletpaymentData } = useSelector((state) => state.wallet);

  const [errorMessageRecharge, SetErrorMessageRecharge] = useState('loading');
  const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
  const [ResponseData, SetResponseData] = useState(null);
  const { handleProceedRecharge } = usePaymentProcessRecharge({
    SetErrorMessageRecharge: SetErrorMessageRecharge,
    setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
    SetResponseData: SetResponseData,
  });

  const navigate = useNavigate();
  // const walletpaymentData = useSelector(selectwalletpaymentData);
  const BookingDetails = useSelector(selectBookingDetails);
  const BookingDetailsStatus = useSelector(selectBookingDetailsStatus);
  const user = useSelector(selectCurrentUser)

  const [TotalPayable, setTotalGrand] = useState(0)
  const [TotalBagPrice, setTotalBagPrice] = useState(0)
  const [TotalMealPrice, setTotalMealPrice] = useState(0)
  const [BookingData, setBookingData] = useState([]);
  const [Sectors, setSectors] = useState([]);
  const [fare, setfare] = useState([]);
  const [TotalSSR, setTotalSSR] = useState(0)
  const [SeatPrice, setSeatPrice] = useState(0);
  const [params, setparams] = useState([]);
  const [couponlist, setcouponlist] = useState([]);
  const [customer, setMemberDetails] = useState([])
  const [usereward, setUsereward] = useState(false)
  const [usewallet, setUsewallet] = useState(false)
  const [WalletPayment, setWalletPayment] = useState(false)
  const [WalletDisable, setWalletDisable] = useState(false)
  const [OnlinePayment, setOnlinePayment] = useState(false)
  const [TnC, setTnC] = useState(false)
  const [isHoldAllowed, setisHoldAllowed] = useState(0)
  const [isBookingStatus, setisBookingStatus] = useState(0)
  const [bookable_balance, setbookable_balance] = useState(0)
  const [total_rewardearn, settotal_rewardearn] = useState(0)
  const [PayType, SetPayType] = useState(1);
  const [currency, setCurrency] = useState({
    CurrencyRate: "1",
    CurrencyTitle: "INR",
    CurrencyId: 1,
  }); // 15 min session

  useEffect(() => {
    dispatch(resetBookingDetails());
    if (BookingID && currency) {
      dispatch(fetchBookingDetails({ BookingID, currency }));
      let postData = {
        BookingID: BookingID
      }
      const fetchcouponlist = async () => {
        const response = await dispatch(
          getcouponlist({ postData })
        ).unwrap();
        const Resultdata = response.data;

        if (Resultdata.status.success) {
          const coupons = [...Resultdata.data].sort((a, b) => {
            if (b.DefaultApply !== a.DefaultApply) {
              return b.DefaultApply - a.DefaultApply;
            }
            return (b.eligible === true) - (a.eligible === true);
          });
          setcouponlist(coupons);

        }
      }
      fetchcouponlist()

    }
  }, [BookingID, dispatch]);

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft((t) => (t > 0 ? t - 1 : 0));
  //   }, 1000);
  //   return () => clearInterval(timer);
  // }, []);

  const [paymentMode, SetpaymentMode] = useState(1);
  const [CouponCode, SetCouponCode] = useState('');
  const [discount_amount, SetDiscountAmount] = useState(0);
  const [convenience, SetConvenience] = useState(0);
  const [DiscountMessage, SetDiscountMessage] = useState('');

  const [bookingProcess__, setBookingProcess] = useState({});
  const validationData = BookingDetails || {};
  const validationStatus = BookingDetailsStatus || "idle";
  const isLoading = validationStatus === "loading";

  const paymentModeHandle = (event) => {
    const { value, checked } = event.target;
    SetpaymentMode(value)
    if (paymentMode == 3) {
      setUsewallet(false)
    }
  }
  const UseWalletHandle = (event) => {
    const { value, checked } = event.target;
    setUsewallet(checked)
  }

  useEffect(() => {
    if (validationStatus === "succeeded" && validationData) {
      const data = validationData.data
      if (validationData.status.success) {
        setbookable_balance(validationData.WalletBalance.balances.bookable_balance)
        settotal_rewardearn(validationData.WalletBalance.balances?.reward_balance?.total_rewardearn || 0)
        setBookingData(data.BookingDetails)
        let isHoldAllowed_ = data.BookingDetails[0].isHoldAllowed;
        let IsHoldWithSSR = data.BookingDetails[0].IsHoldWithSSR;
        setisBookingStatus(data.BookingDetails[0].BookingStatus);
        if (data.fare.TotalSSR > 0 && IsHoldWithSSR === 1 && isHoldAllowed_ === 1) {
          setisHoldAllowed(1)
        } else if (isHoldAllowed_ === 1 && data.fare.TotalSSR === 0 && IsHoldWithSSR === 0) {
          setisHoldAllowed(isHoldAllowed_)
        }

        setSectors(data.Sectors)
        setfare(data.fare)
        setfare((prev) => {
          const applyOn = Number(fare?.Couponapplyon) || 0;
          const discount = discount_amount || 0;
          const newTotalGrand =
            applyOn === 5
              ? prev.TotalGrand + convenience + (prev.TotalDiscount || 0) + (prev.TDSEarn || 0)
              : prev.TotalGrand + convenience;

          const updated = {
            ...prev,
            convenience: convenience,
            CouponDiscount: discount,
            Couponapplyon: applyOn,
            TotalGrand: newTotalGrand,
          };
          return updated;
        });

        // setfare((prev) => ({
        //   ...prev,
        //   ['CouponDiscount']: discount_amount,
        // }));
        setMemberDetails(data.customer)

        let TotalGrand = 0;
        if (PayType === '2') {
          TotalGrand = (data.fare.BookAmt + data.fare.ProAmt + data.fare.GSTOnPro);
        } else if (paymentMode === '3') {
          TotalGrand = (fare?.Couponapplyon === 5) ? (fare?.TotalGrand + data.fare.Totalagentmarkup) - discount_amount : (data.fare?.TotalGrand + data.fare.Totalagentmarkup) - discount_amount;
        } else {
          TotalGrand = (fare?.Couponapplyon === 5) ? fare?.TotalGrand - discount_amount : data.fare?.TotalGrand - discount_amount;
        }
        if (usewallet && paymentMode === '2') {
          TotalGrand = (TotalGrand - bookable_balance)
        }
        if (usereward && total_rewardearn > 0) {
          TotalGrand = (TotalGrand - total_rewardearn)
        }
        TotalGrand = Math.ceil(TotalGrand)
        setTotalGrand(TotalGrand);

        let bookingPro = {
          // "isapibooking": true, Totalagentmarkup
          "usewallet": (paymentMode === '3') ? false : usewallet,
          "paymentMode": 1,//paymentMode,
          "IsFlexiPayment": (PayType === '2') ? true : false,
          "usereward": usereward,
          "IsCouponApply": (CouponCode) ? true : false,
          "coupon_code": CouponCode,
        }

        const createdDate = new Date(data.BookingDetails[0].created_at.replace(" ", "T")); // "YYYY-MM-DDTHH:mm:ss"
        // Current date
        const now = new Date();
        // Difference in milliseconds
        const diffMs = now - createdDate;
        // Convert to minutes
        const diffMinutes = Math.floor(diffMs / 60000);
        if (diffMinutes > 16) {
          toast.error('Request booking is not longer available.Please try different flight', { autoClose: 3000 })
          //navigate('/flight')
        }

        setBookingProcess(bookingPro)
        if (data.BookingDetails[0].BookingStatus == 22 || data.BookingDetails[0].BookingStatus == 20 || data.BookingDetails[0].BookingStatus == 26 || data.BookingDetails[0].BookingStatus == 1 || data.BookingDetails[0].BookingStatus == 3) {
          toast.error('Request booking is not longer available.Please try different flight', { autoClose: 2000 });
          navigate('/booking-calendar')
          ViewTicketDetails()
        } else {
          // toast.error('Request booking is not longer available.Please try different flight', { autoClose: 2000 });
          // navigate('/dashboard')
        }
        let encrypt = encryptAES(JSON.stringify(bookingPro), getapiKey(), getapiKey())
        let txnid = "TXN" + Date.now()
        const hash = WalletUtils.walletCode(txnid, txnid, TotalGrand.toFixed(2), data.customer[0].fname, data.customer[0].mobile, data.customer[0].email, "Flight Booking");
        const customerInfo = {
          txnid: txnid,
          amount: TotalGrand.toFixed(2),
          name: data.customer[0].fname,
          email: data.customer[0].email,
          phone: data.customer[0].mobile,
          productinfo: "Flight Booking",
          surl: getdomainFullURL() + "/payment/payment-success?planType=1&BookingID=" + data.BookingDetails[0].BookingID,
          furl: getdomainFullURL() + "/payment/payment-success?planType=1&BookingID=" + data.BookingDetails[0].BookingID,
          udf1: data.BookingDetails[0].BookingID,
          udf2: "1",
          udf3: "Web-B2B",
          udf4: (user?.UserData.user.UserType === 7) ? user?.UserData.user.UserSysId : user?.UserData?.user?.id, // customer id
          udf5: user?.UserData?.user?.AgencyID,
          udf6: "INR",
          udf7: encrypt,
          udf8: "",
          udf9: "",
          udf10: "",
          securecode: hash,
        };

        setFormData(customerInfo)
        VeryfyPaymentMode(validationData.WalletBalance.balances.bookable_balance, TotalGrand)
      } else {
        toast.error(data.message, { autoClose: 2000 });
      }
    } else if (validationStatus === "failed") {
      toast.error('Request flight is not longer available.Please try different flight', { autoClose: 2000 });
    }
  }, [validationStatus, validationData, PayType, discount_amount, paymentMode, usewallet, usereward]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };


  const UseRewardtHandle = (event) => {
    const { value, checked } = event.target;
    setUsereward(checked)
  }
  const TryAgain = (event) => {
    // navigate('/dashboard')
    setIsModalSector(false)
  }
  const ViewTicketDetails = () => {
    window.location.href = `/flight/booking-confirmation/${BookingID}`;
    // navigate(`/flight/booking-confirmation/${BookingData[0].BookingID}`)
  }

  const VeryfyPaymentMode = (WalletBalance, fareData) => {

    if (WalletBalance >= Number(fareData.toFixed(2))) {
      setWalletPayment(true)
      setOnlinePayment(false)
      setWalletDisable(false)
    } else {
      setWalletDisable(true)
      setOnlinePayment(true)
    }
  }
  const [CouponLoad, setCouponLoad] = useState(false);
  const [CouponLoadTC, setCouponLoadTC] = useState(false);
  const [CouponTC, setCouponTC] = useState({});
  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [bookingStatus, setbookingStatus] = useState('loading');
  const [ErrorMessage, SetErrorMessage] = useState('');
  const [paymentAccept, SetpaymentAccept] = useState(1);
  const [savetype, SetSavetype] = useState(0);

  useEffect(() => {
    if (couponlist.length > 0) {
      // if (couponlist.length > 0 && (user?.UserData?.user?.id === 83 || user?.UserData?.user?.id === 98)) {
      setTimeout(() => {
        const defaultCoupon = couponlist.filter(c => c.DefaultApply === 1);
        if (defaultCoupon && defaultCoupon[0]?.eligible) {
          handleCoupon({
            target: {
              value: defaultCoupon[0]?.CouponCode,
              checked: true,
            },
          });
        }
      }, 3000);
    }

  }, [BookingData, couponlist]);


  const paymentModeHandleAccept = (event) => {
    const { value, checked } = event.target;
    setTnC(checked)
  }

  const HandleCouponTC = (item) => {
    setCouponLoadTC(true)
    setCouponTC(item);
  }
  const RemoveCoupon = () => {
    SetConvenience(0);
    SetDiscountAmount(0);
    SetCouponCode('');
    SetDiscountMessage('');
    setfare((prev) => ({
      ...prev,
      ['CouponDiscount']: 0,
      ['convenience']: 0,
    }));
  }
  const handleCoupon = async (event) => {
    const { value, checked } = event.target;
    SetCouponCode(value);
    if (checked) {
      ApplyCoupon(value)
    }
  }
  const ApplyCoupon = async (value) => {
    try {
      const postData = {
        "customer_id": user?.UserData?.user?.id,
        "transaction_amount": fare.TotalGrand,
        "coupon_code": (value) ? value : CouponCode,
        "BookingID": BookingID,
      }
      setCouponLoad(true)
      const response = await dispatch(
        validatecoupons({ postData })
      ).unwrap();
      const Resultdata = response.data;

      if (Resultdata.status.success) {
        setCouponLoad(false)
        toast.success(Resultdata.data.message, { autoClose: 5000 });
        if (Resultdata.data.discount_amount > 0) {
          // setfare((prev) => ({
          //   ...prev,
          //   ['CouponDiscount']: Resultdata.data.discount_amount,
          //   ['Couponapplyon']: Resultdata.data.Couponapplyon,
          //   ['TotalGrand']: (Resultdata.data.Couponapplyon === 5)?fare.TotalGrand + fare?.TotalDiscount:fare.TotalGrand,
          // }));
          setfare((prev) => {
            const applyOn = Number(Resultdata.data.Couponapplyon) || 0;
            const discount = (Resultdata.data.discount_amount) || 0;
            const convenience = parseFloat(Resultdata.data.convenience) || 0;

            const newTotalGrand =
              applyOn === 5 ? prev.TotalGrand + convenience + (prev.TotalDiscount || 0) + (prev.TDSEarn || 0) : prev.TotalGrand + convenience;

            const updated = {
              ...prev,
              convenience: convenience,
              CouponDiscount: discount,
              Couponapplyon: applyOn,
              TotalGrand: newTotalGrand,
            };
            return updated;
          });

          SetConvenience(parseFloat(Resultdata.data.convenience));
          SetDiscountAmount(Resultdata.data.discount_amount);
          SetDiscountMessage(Resultdata.data.message);

        }
      } else {
        setCouponLoad(false)
        toast.error(Resultdata.message, { autoClose: 3000 });
      }
    } catch (error) {
      setCouponLoad(false)
      toast.error(error?.data?.message, { autoClose: 3000 });
      console.log(error);
    }
  }

  const PayTypeModeHandle = (event) => {
    const { value, checked } = event.target;
    SetPayType(value)
  }
  // usePreventRefresh(bookingStatus === "loading");
  // usePreventBack(bookingStatus === "loading");

  useEffect(() => {
    // If payment is initiated and we have access key, open the modal
    if (paymentInitiated && paymentData && paymentData.accessKey) {
      openPaymentModal();
    }
  }, [paymentInitiated, paymentData]);

  useEffect(() => {
    if (walletpaymentStatus === true && walletpaymentData?.status?.success === true) {
      // if (user?.UserData?.user?.AgencyID !== 42) {
      //   InitiatedBookingProcess(0)
      // }

    } else if (walletpaymentData) {
      SetErrorMessage(walletpaymentData?.message)
      setbookingStatus('paymentfailed')
      toast.error(walletpaymentData?.message, { autoClose: 2000 });
    }
  }, [walletpaymentStatus, walletpaymentData]);

  const [formData, setFormData] = useState({});
  const openPaymentModal = () => {
    try {
      openEasebuzzPaymentModal(
        paymentData.enviroment,
        paymentData.accessKey,
        formData,
        (response) => {
          // Handle the payment response
          dispatch(handleEasebuzzResponse(response));
          // You might want to verify the payment with your backend here
          if (response.status === 'success') {
            const WalletopUp = {
              "customer_id": user?.UserData?.user.id,
              "currency": currency.CurrencyTitle,
              "amount": fare.TotalGrand,
              "PaymentMode": response.card_type + '-Web-B2B',
              "ReferenceNo": BookingData[0].BookingID,
              "Notes": 'Wallet Recharge - ' + response.easepayid
            }

            setTimeout(() => {
              // InitiatedBookingProcess()
              ViewTicketDetails()
            }, 3000);
            // if (user?.UserData?.user?.AgencyID === 42) {
            //   setTimeout(() => {
            //     if (user?.UserData?.user?.AgencyID === 42) {
            //       // InitiatedBookingProcess()
            //       ViewTicketDetails()
            //     }
            //   }, 3000);
            // }

            // if (user?.UserData?.user?.AgencyID !== 42) {
            //   dispatch(clearWalletError());
            //   dispatch(DoWalletTopUp({ WalletopUp, currency })).unwrap();
            // }
            // dispatch(verifyEasebuzzPayment({
            //   txn_id: response.txnid,
            //   amount: formData.amount,
            //   email: formData.email
            // }));
          } else {
            toast.error(response.status, { autoClose: 2000 });
            SetErrorMessage(response.status)
            setbookingStatus('paymentfailed')
            setTimeout(() => {
              window.location.reload()
            }, 3000);
          }
        }
      );
    } catch (error) {
      SetErrorMessage('Failed to proceed payment')
      setbookingStatus('paymentfailed')
      console.error('Failed to open payment modal:', error);
    }
  };
  const [openConfirm, setOpenConfirm] = useState(false);

  const InitiatedBookingProcess = async (isHoldbooking) => {
    const bookingProcess = {
      "isHoldbooking": isHoldbooking,
      "isapibooking": true,
      "usewallet": (paymentMode === '3') ? false : usewallet,
      "paymentMode": 1,//paymentMode,
      "IsFlexiPayment": (PayType === '2') ? true : false,
      "usereward": usereward,
      "BookingID": BookingData[0].BookingID,
      "paymentInfos": [
        {
          "amount": fare.TotalGrand
        }
      ],
      "IsCouponApply": (CouponCode) ? true : false,
      "coupon_code": CouponCode,
      "currency": currency,
      "gstInfo": {},
      "deliveryInfo": {
        "emails": customer[0].email,
        "contacts": customer[0].mobile,
        "countrycode": customer[0].countrycode
      }
    }

    // console.log(bookingProcess);
    // return false;


    try {
      const response = await dispatch(
        doBookingProcess({ bookingProcess, currency })
      ).unwrap();
      if (response.data.status.success) {
        setbookingStatus('success')
        setTimeout(function () {
          ViewTicketDetails()
        }, 2000);

      } else {
        SetErrorMessage(response.data.message)
        setbookingStatus('failed')
        toast.error(response.data.message, { autoClose: 2000 });
        setTimeout(() => {
          window.location.reload()
        }, 2000);
      }
      // console.log("API Response:", response);
    } catch (error) {
      toast.error('We regret to inform you that your booking could not be completed due to an internal issue.', { autoClose: 2000 });
      console.error("Error:", error);
    }
  }

  const handleProceed = async (e) => {
    e.preventDefault();
    let savetype = e.nativeEvent.submitter.attributes.savetype.value
    SetSavetype(savetype)
    if (!paymentAccept) {
      toast.error('Please accept the Terms & Conditions to continue.', { autoClose: 2000 });
    } else {
      if (savetype === '2') {
        setIsModalSector(true)
        InitiatedBookingProcess(1)
        return false;
      }
      if (paymentMode == 1) {
        if (bookable_balance >= Number(TotalPayable.toFixed(2))) {
          setIsModalSector(true)
          InitiatedBookingProcess(0)
          return false;
        } else {
          toast.error('Insufficient balance : Please contact the Business Team to topup the account.', { autoClose: 3000 });
          return false;
        }
      } else if (paymentMode == 2 || paymentMode == 3) {
        setIsModalSector(true)
        // dispatch(clearError());
        // dispatch(initiateEasebuzzPaymentThunk(formData));
        handleProceedRecharge(formData);
      }
    }

  };

  useEffect(() => {

    if (paymentHookStatusRecharge === "success") {
      toast.success("Payment proceed successful. Please wait...", { autoClose: 4000 });
      setTimeout(() => {
        ViewTicketDetails()
      }, 2000);
    } else if (paymentHookStatusRecharge === "paymentfailed") {
      SetErrorMessage('Failed to proceed payment')
      setbookingStatus('paymentfailed')
      setTimeout(() => {
        // window.location.reload()
      }, 2000);
      toast.error("Payment proceed failed. plese contact with support team.", { autoClose: 4000 });
    }
  }, [paymentHookStatusRecharge, errorMessageRecharge]);

  return (
    <>
      {isLoading && BookingData.length === 0 ? (
        <>
          <div className="bg-gray-50 min-h-screen pb-16 mt-2">
            <div className="flex items-center justify-center space-x-12 px-8 py-4 bg-white shadow">
              <Step icon={<Plane className="w-5 h-5 text-white" />} title="FIRST STEP" subtitle="Flight Itinerary" active />
              <Step icon={<User className="w-5 h-5 text-gray-400" />} title="SECOND STEP" subtitle="Passenger Details" active />
              <Step icon={<CheckCircle className="w-5 h-5 text-gray-400" />} title="THIRD STEP" subtitle="Review" />
              <Step icon={<CreditCard className="w-5 h-5 text-gray-400" />} title="FINISH STEP" subtitle="Payments" />
            </div>
            <ItineraryLoader />
          </div>
        </>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-16 mt-2">
          {/* Stepper */}
          <div className="flex items-center justify-center space-x-12 px-8 py-4 bg-white shadow">
            <Step icon={<Plane className="w-5 h-5 text-white" />} title="FIRST STEP" subtitle="Flight Itinerary" active />
            <Step icon={<User className="w-5 h-5 text-white" />} title="SECOND STEP" subtitle="Passenger Details" active />
            <Step icon={<CheckCircle className="w-5 h-5 text-white" />} title="THIRD STEP" subtitle="Review" active />
            <Step icon={<CreditCard className="w-5 h-5 text-gray-400" />} title="FINISH STEP" subtitle="Payments" />
          </div>

          <div className="flex flex-col md:flex-row gap-6 max-w-7xl mx-auto mt-6 px-4">
            {/* Flight details */}
            <div className="flex-1 space-y-6">
              {/* <h2 className="text-xl font-semibold">Flight Details</h2> */}

              {BookingData.map((f, idx) => (
                <div key={idx} className="bg-white rounded-lg shadow p-4 space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold">
                      {f.SoCity} → {f.DeCity}{" "}
                      <span className="text-sm font-normal text-gray-500">
                        on {format(new Date(f.FromUTCTime), "MMM dd, EEE, HH:mm")}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500 flex items-center gap-1">
                      <Clock className="w-4 h-4" /> {f.Duration}
                    </span>
                  </div>

                  {f.Segments.map((SegItem, Segkey) => (
                    <div key={Segkey}>
                      <div className="flex gap-4">
                        <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                          <img
                            src={SegItem.filePath}
                            alt={SegItem.AirlineName}
                            className="object-contain rounded-md w-full h-full"
                          />
                        </div>

                        <div className="flex-1">
                          <p className="font-semibold">
                            {SegItem.AirlineName}{" "}
                            <span className="text-gray-500">{SegItem.FlightNumber}</span>
                          </p>

                          <div className="flex items-center gap-6 mt-2">
                            <div>
                              <p className="font-bold">{format(new Date(SegItem.originDepTime), "MMM dd, EEE, HH:mm")}</p>
                              <p className="text-sm text-gray-600">
                                {SegItem.originCityName}, {SegItem.originCountryName}
                              </p>
                              <p className="text-sm text-gray-600">{SegItem.originAirportName}</p>
                              <p className="text-xs text-gray-400">Terminal {SegItem.DepTerminal}</p>
                            </div>

                            <ArrowRight className="w-6 h-6 text-gray-400" />

                            <div>
                              <p className="font-bold">{format(new Date(SegItem.destinationArrTime), "MMM dd, EEE, HH:mm")}</p>
                              <p className="text-sm text-gray-600">
                                {SegItem.destinationCityName}, {SegItem.destinationCountryName}
                              </p>
                              <p className="text-sm text-gray-600">{SegItem.destinationAirportName}</p>
                              <p className="text-xs text-gray-400">Terminal {SegItem.ArrTerminal}</p>
                            </div>

                            <div>
                              <p className="font-bold">{SegItem.FlightDuration}</p>
                              <p className="text-sm text-gray-600">{f.FareLists.FareClass}</p>
                              <p className="text-xs text-gray-400">{f.FareLists.RefundableTxt}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Layover (if not last segment) */}
                      {SegItem.GroundTime > 0 && (
                        <div className="text-center my-4">
                          <span className="bg-blue-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                            Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                          </span>
                        </div>
                      )}

                      <div className="text-sm text-gray-600 border-b pt-2 pb-2">
                        <p>
                          🧳 (Adult) Check-in:{f.FareLists.Checkin} Cabin: {f.FareLists.Cabin}
                          <span style={{ float: 'right' }} className="text-red-500">{f.FareLists.fareIdentifier}</span>
                        </p>
                      </div>
                    </div>
                  ))}


                  <div className="mt-4">
                    {/* Header */}
                    <div className="flex items-start justify-between">
                      <h3 className=" font-semibold text-gray-800">
                        Passenger Details ({customer.length})
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 overflow-x-auto ">
                      <table className="min-w-full border  text-sm">
                        <thead className="bg-gray-100 text-gray-700">
                          <tr>
                            <th className="px-3 py-2 border">#</th>
                            <th className="px-3 py-2 border text-left">Name & Age</th>
                            <th className="px-3 py-2 border text-left">Sector</th>
                            <th className="px-3 py-2 border text-left whitespace-nowrap">
                              Checkin | Cabin
                            </th>
                            <th className="px-3 py-2 border text-left" colSpan="3">
                              Seat, Baggage & Meal
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {f.Travellers.length > 0 &&
                            f.Travellers.map((citem, keys) => (
                              <tr
                                key={keys + "customer"}
                                className=" border-b"
                              >
                                <td className="px-3 py-2 border text-center font-medium">
                                  {keys + 1}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap text-gray-800">
                                  {citem.title}. {citem.fname} {citem.lname} ({citem.PaxType}) <br />
                                  {citem.docid && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.docid ? "ID-" + citem.docid : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.dateofbirth && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.dateofbirth ? "DOB-" + citem.dateofbirth : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.passno && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.passno ? "Passport No-" + citem.passno : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Expiry-" +
                                          Moment(citem.passexp).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Issue-" +
                                          Moment(citem.passisse).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno ? "Issue Country-" + citem.passnational : ""}
                                      </small>
                                    </>
                                  )}
                                  {citem.FFdetail.length > 0 &&
                                    citem.FFdetail.map((ffv, kf) => (
                                      <React.Fragment key={"ItemsSeg" + kf}>
                                        {ffv.FFNumber && (
                                          <>
                                            <small className="text-gray-500">
                                              Frequent Flyer Airline: {ffv.FFAirlineCode}
                                            </small>
                                            <br />
                                            <small className="text-gray-500">
                                              Frequent Flyer No: {ffv.FFNumber}
                                            </small>
                                          </>
                                        )}
                                      </React.Fragment>
                                    ))}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap">
                                  {Sectors.map((sec, k) => (
                                    <div
                                      key={k + "sectttt"}
                                      className="mb-1 text-gray-700 font-medium"
                                    >
                                      {sec}
                                    </div>
                                  ))}
                                </td>
                                <td className="px-3 py-2 border text-gray-700">
                                  {citem.CheckinBaggage} | {citem.CabinBaggage}
                                </td>
                                <td className="px-3 py-2 border" colSpan="3">
                                  {Object.keys(citem.SelectedSeat).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedSeat.map((addons, ad) => (
                                        <li key={ad + "selectedseat"}>
                                          Seat No - {addons[0].seatNo}
                                        </li>
                                      ))}
                                    </ul>
                                  )}

                                  {Object.keys(citem.SelectedBag).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedBag.map((addons, ad) => (
                                        <li key={ad + "selectedbag"}>{addons[0].Weight}</li>
                                      ))}
                                    </ul>
                                  )}
                                  {Object.keys(citem.SelectedMeal).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedMeal.map((addons, ad) => (
                                        <li key={ad + "selectedmeal"}>
                                          {addons[0].Description}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))}

              <form onSubmit={handleProceed} className="mui-form">
                <>
                  {/* <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    <div className="flex items-start justify-between">
                      <h3 className=" font-semibold text-gray-800">
                        Passenger Details ({customer.length})
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 overflow-x-auto ">
                      <table className="min-w-full border  text-sm">
                        <thead className="bg-gray-100 text-gray-700">
                          <tr>
                            <th className="px-3 py-2 border">#</th>
                            <th className="px-3 py-2 border text-left">Name & Age</th>
                            <th className="px-3 py-2 border text-left">Sector</th>
                            <th className="px-3 py-2 border text-left whitespace-nowrap">
                              Checkin | Cabin
                            </th>
                            <th className="px-3 py-2 border text-left" colSpan="3">
                              Seat, Baggage & Meal
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {customer.length > 0 &&
                            customer.map((citem, keys) => (
                              <tr
                                key={keys + "customer"}
                                className=" border-b"
                              >
                                <td className="px-3 py-2 border text-center font-medium">
                                  {keys + 1}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap text-gray-800">
                                  {citem.title}. {citem.fname} {citem.lname} ({citem.PaxType}) <br />
                                  {citem.docid && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.docid ? "ID-" + citem.docid : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.dateofbirth && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.dateofbirth ? "DOB-" + citem.dateofbirth : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.passno && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.passno ? "Passport No-" + citem.passno : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Expiry-" +
                                          Moment(citem.passexp).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Issue-" +
                                          Moment(citem.passisse).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno ? "Issue Country-" + citem.passnational : ""}
                                      </small>
                                    </>
                                  )}
                                  {citem.FFdetail.length > 0 &&
                                    citem.FFdetail.map((ffv, kf) => (
                                      <React.Fragment key={"ItemsSeg" + kf}>
                                        {ffv.FFNumber && (
                                          <>
                                            <small className="text-gray-500">
                                              Frequent Flyer Airline: {ffv.FFAirlineCode}
                                            </small>
                                            <br />
                                            <small className="text-gray-500">
                                              Frequent Flyer No: {ffv.FFNumber}
                                            </small>
                                          </>
                                        )}
                                      </React.Fragment>
                                    ))}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap">
                                  {Sectors.map((sec, k) => (
                                    <div
                                      key={k + "sectttt"}
                                      className="mb-1 text-gray-700 font-medium"
                                    >
                                      {sec}
                                    </div>
                                  ))}
                                </td>
                                <td className="px-3 py-2 border text-gray-700">
                                  {citem.CheckinBaggage} | {citem.CabinBaggage}
                                </td>
                                <td className="px-3 py-2 border" colSpan="3">
                                  {Object.keys(citem.SelectedSeat).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedSeat.map((addons, ad) => (
                                        <li key={ad + "selectedseat"}>
                                          Seat No - {addons[0].seatNo}
                                        </li>
                                      ))}
                                    </ul>
                                  )}

                                  {Object.keys(citem.SelectedBag).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedBag.map((addons, ad) => (
                                        <li key={ad + "selectedbag"}>{addons[0].Weight}</li>
                                      ))}
                                    </ul>
                                  )}
                                  {Object.keys(citem.SelectedMeal).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedMeal.map((addons, ad) => (
                                        <li key={ad + "selectedmeal"}>
                                          {addons[0].Description}
                                        </li>
                                      ))}
                                    </ul>
                                  )}

                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div> */}
                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    <div className="flex items-start justify-between">
                      <h3 className=" font-semibold text-gray-800">
                        Contact Details
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Mobile</label>
                        <span className="text-body">+{customer[0]?.countrycode} {customer[0]?.mobile}</span>
                      </div>
                      <div className="sm:col-span-2 relative">
                        <label className="block text-sm font-medium text-gray-600">Email</label>
                        <span className="text-body">{customer[0]?.email}</span>
                      </div>
                    </div>
                  </div>
                  {BookingData[0]?.isgstapply === true && (
                    <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                      <div className="flex items-start justify-between">
                        <h3 className=" font-semibold text-gray-800">
                          GST Details
                        </h3>
                      </div>
                      <hr className="border-t border-gray-200 my-3" />
                      <div className="mt-3 grid grid-cols-1 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-600">GSTIN Number</label>
                          <span className="text-body">{BookingData[0]?.gstnnumber}</span>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-600">Company Name</label>
                          <span className="text-body">{BookingData[0]?.companyname}</span>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-600">Email ID</label>
                          <span className="text-body">{BookingData[0]?.gstemail}</span>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-600">Phone Number</label>
                          <span className="text-body">{BookingData[0]?.gstphone}</span>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-600">Address/State</label>
                          <span className="text-body">{BookingData[0]?.gstaddress}, {BookingData[0]?.gststate}</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    {/* Header */}
                    <div className="flex items-center justify-between">
                      <h3 className="font-semibold">
                        Payment Mode

                      </h3>
                      <span className="font-semibold text-blue-500 flex items-center gap-1">
                        Total Cost <CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand + fare?.Totalagentmarkup) - fare?.CouponDiscount} />
                      </span>
                    </div>

                    <hr className="border-t border-gray-200 my-3" />

                    <ul className="flex gap-6 mt-4">
                      {fare.BookAmt > 0 && isBookingStatus !== 28 && (
                        <>
                          <li>
                            <label
                              htmlFor="FullPay"
                              className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                            >
                              <input
                                type="radio"
                                id="FullPay"
                                value="1"
                                name="PayType"
                                onChange={PayTypeModeHandle}
                                checked={PayType == 1}
                                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                              />
                              <span className="text-sm font-medium text-gray-700">
                                Full Pay:
                                {usewallet ? (
                                  <>
                                    (<CurFt currency={fare?.symbol || "INR"} price={(fare?.TotalGrand + TotalSSR) - (fare?.CouponDiscount + bookable_balance)} />)
                                  </>
                                ) : (
                                  <>
                                    (<CurFt currency={fare?.symbol || "INR"} price={(fare?.TotalGrand + TotalSSR) - fare?.CouponDiscount} />)
                                  </>
                                )}

                              </span>
                            </label>
                          </li>
                          <li>
                            <label
                              htmlFor="Part"
                              className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                            >
                              <input
                                type="radio"
                                id="Part"
                                value="2"
                                onChange={PayTypeModeHandle}
                                name="PayType"
                                checked={PayType == 2}
                                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                              />
                              <span className="text-sm font-medium text-gray-700">
                                Part Pay: (<CurFt currency={fare?.symbol || "INR"} price={fare.BookAmt + fare.ProAmt + fare.GSTOnPro} />)
                              </span>
                            </label>
                          </li>
                        </>
                      )}
                    </ul>

                    <ul className="flex gap-6 mt-4">
                      <li>
                        <label
                          htmlFor="wallet"
                          className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                        >
                          <input
                            type="radio"
                            id="wallet"
                            value="1"
                            name="paymentMode"
                            onChange={paymentModeHandle}
                            checked={paymentMode == 1}
                            disabled={WalletDisable}
                            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          />
                          <span className="text-sm font-medium text-gray-700">
                            Wallet Bal: (<CurFt currency={fare?.symbol || "INR"} price={bookable_balance} />)
                          </span>
                        </label>

                        {(paymentMode == 2) && bookable_balance <= parseFloat((fare?.TotalGrand + TotalSSR)) && bookable_balance > 0 && (
                          <div className="custom-control custom-checkbox mt-2 text-blue-500">
                            <input defaultChecked={false} onChange={UseWalletHandle} id="accepttnc" value="1" modename="Wallet" className="custom-control-input" type="checkbox" />
                            <label className="custom-control-label" htmlFor="accepttnc"> Use Wallet (<CurFt currency={fare?.symbol || "INR"} price={bookable_balance} />)</label>
                          </div>
                        )}

                      </li>

                      <li>
                        <label
                          htmlFor="online"
                          className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                        >
                          <input
                            type="radio"
                            id="online"
                            value="2"
                            onChange={paymentModeHandle}
                            name="paymentMode"
                            defaultChecked={false}
                            // checked={paymentMode == 2}
                            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          />
                          <span className="text-sm font-medium text-gray-700">Self Card
                            {/* {PayType === '2' ? (
                              <>
                                (<CurFt currency={fare?.symbol || "INR"} price={Math.ceil(fare.BookAmt + fare.ProAmt + fare.GSTOnPro)} />)
                              </>
                            ) : (
                              <>
                                {usewallet ? (
                                  <>
                                    (<CurFt currency={fare?.symbol || "INR"} price={Math.ceil((fare?.TotalGrand + TotalSSR) - (fare?.CouponDiscount + bookable_balance))} />)
                                  </>
                                ) : (
                                  <>
                                    (<CurFt currency={fare?.symbol || "INR"} price={Math.ceil((fare?.TotalGrand + TotalSSR) - fare?.CouponDiscount)} />)
                                  </>
                                )}
                              </>
                            )} */}

                          </span>
                        </label>
                      </li>
                      {PayType !== '2' && (
                        <li>
                          <label
                            htmlFor="online"
                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                          >
                            <input
                              type="radio"
                              id="online"
                              value="3"
                              onChange={paymentModeHandle}
                              defaultChecked={false}
                              name="paymentMode"
                              // checked={paymentMode == 3}
                              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">Customer Card
                              {/* <>
                                (<CurFt currency={fare?.symbol || "INR"} price={Math.ceil((fare?.TotalGrand + TotalSSR + fare?.Totalagentmarkup) - fare?.CouponDiscount)} />)
                              </> */}
                            </span>
                          </label>
                        </li>
                      )}

                    </ul>
                    {total_rewardearn > 0 && (
                      <ul className="flex gap-6 mt-4">
                        <li>
                          <label
                            htmlFor="oncredit"
                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                          >
                            <input
                              type="checkbox"
                              id="usereward"
                              onChange={UseRewardtHandle}
                              name="usereward"
                              checked={usereward}
                              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">Use Reward ({total_rewardearn})</span>
                          </label>
                        </li>
                      </ul>
                    )}



                    <div className="flex items-center justify-between pt-2">
                      {/* Left side */}
                      <button
                        type="button"
                        className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                      >
                        Back
                      </button>

                      {/* Right side buttons */}
                      <div className="flex gap-3">
                        {isHoldAllowed === 1 && isBookingStatus !== 28 && (
                          <button
                            savetype='2'
                            type="submit"
                            className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                          >
                            Hold
                          </button>
                        )}

                        <button
                          onClick={() => setOpenConfirm(true)}
                          type="button"
                          className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                        >
                          Proceed To Pay
                        </button>
                      </div>
                    </div>

                    <div className="form-row mt-4">
                      <div className="col-sm-12 form-group">
                        <div className="custom-control custom-checkbox text-gray-500">
                          <input defaultChecked={true} onClick={paymentModeHandleAccept} id="accepttncTerms" value="1" modename="accepttncTerms" className="custom-control-input" type="checkbox" />
                          <label className="custom-control-label" htmlFor="accepttncTerms"> I understand and agree to the rules, <a href='/privacy-policy' target='_blank' className="loadtc" id="loadpp">Privacy Policy</a>, <a href='/termsofuse' target='_blank' className="loadtc" id="loadua">User Agreement</a> and <a href='/termsofuse' target='_blank' className="loadtc" id="loadtnc">Terms &amp; Conditions</a></label>
                        </div>
                      </div>
                    </div>

                  </div>

                  {openConfirm && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                        <h2 className="text-lg font-semibold mb-4">
                          Confirm before proceed!
                        </h2>
                        <p className="text-sm text-gray-600 mb-6">
                          Are you sure you want to proceed with this booking?
                        </p>
                        <div className="flex justify-center gap-3">
                          <button
                            onClick={() => setOpenConfirm(false)}
                            className="px-4 py-2 rounded-lg border border-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            savetype='1'
                            type="submit"
                            className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                          >
                            Proceed To Pay
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </form>


            </div>

            {/* Fare summary sidebar */}
            <aside className="w-full md:w-80 self-start md:sticky md:top-4 self-start max-h-[calc(100vh-2rem)] overflow-y-auto">
              <FareSummary params={params} fare={fare} BookingData={BookingData} SeatPrice={SeatPrice} TotalBagPrice={TotalBagPrice} TotalMealPrice={TotalMealPrice} TotalSSR={TotalSSR} user={user} review={true} />
              {couponlist.length > 0 && (
                <div className="w-full max-w-md mx-auto p-2 bg-white rounded-lg border border-gray-200 mt-4">
                  {/* Header */}
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-semibold">Offers & Promo Code</h3>
                    <img
                      src="/icocoupn.svg"
                      alt="promo"
                      className="w-6 h-6"
                    />
                  </div>
                  {/* Coupon Input */}
                  {discount_amount === 0 && (
                    <div className="flex items-center border rounded-lg overflow-hidden mb-4">
                      <input
                        onChange={handleCoupon}
                        type="text"
                        value={CouponCode}
                        placeholder="ENTER COUPON CODE"
                        className="flex-1 px-3 py-2 text-sm text-gray-600 placeholder-gray-400 focus:outline-none"
                      />
                      <button className="px-4 py-2 text-blue-500 font-medium text-sm" onClick={() => ApplyCoupon('')}>Apply</button>
                    </div>
                  )}

                  {/* Applied Coupon Message (Optional - if applied) */}
                  {discount_amount > 0 && (
                    <div className={"mb-4"}>
                      <div className="flex items-center justify-between border border-gray-300 rounded-lg px-3 py-2">
                        <span className="font-medium">{CouponCode}</span>
                        <button className="text-sm text-gray-500 hover:text-red-600" onClick={RemoveCoupon}>Remove</button>
                      </div>
                      <p className="text-green-600 text-sm mt-2 font-medium">
                        {DiscountMessage}
                      </p>
                    </div>
                  )}

                  {/* Coupon Options */}
                  <div className="space-y-3 ">
                    {couponlist.map((item, keys) => (
                      <React.Fragment key={"types" + keys}>
                        {item.eligible ? (
                          <label className="flex items-center gap-3 border border-gray-200 rounded-lg px-3 py-3 cursor-pointer">
                            <input type="radio" name="coupon" checked={CouponCode === item.CouponCode} onClick={handleCoupon} value={item.CouponCode} className="w-4 h-4 text-blue-500" />
                            <div className="flex-1">
                              <span className="font-medium bg-gray-100 border px-2 py-1 rounded text-sm">{item.CouponCode}</span>
                              <p className="text-sm text-gray-700 mt-1" dangerouslySetInnerHTML={TruncatedTextHTML({ text: item.FareRules, max: 100, mode: "end" })} ></p>
                            </div>
                            <a href="#" onClick={() => HandleCouponTC(item)} className="text-blue-500 text-sm">T&amp;C </a>
                          </label>
                        ) : (
                          <label className="flex items-center gap-3 border border-gray-200 rounded-lg px-3 py-3 cursor-pointer opacity-60">
                            <input type="radio" name="coupon" disabled className="w-4 h-4 text-blue-500" />
                            <div className="flex-1">
                              <span className="font-medium bg-gray-100 border px-2 py-1 rounded text-sm flex items-center gap-1">
                                {item.CouponCode} <Lock size={14} />
                              </span>
                              <p className="text-sm text-gray-700 mt-1" dangerouslySetInnerHTML={TruncatedTextHTML({ text: item.FareRules, max: 100, mode: "end" })} ></p>
                            </div>
                            <a href="#" onClick={() => HandleCouponTC(item)} className="text-blue-500 text-sm">T&amp;C</a>
                          </label>
                        )}

                      </React.Fragment>
                    ))}


                  </div>
                </div>
              )}
            </aside>
          </div>


          <Dialog
            open={CouponLoad}
            onClose={() => setCouponLoad(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center text-center">
              <h2 className="text-lg font-semibold border-b pb-2 w-full text-center">
                Please wait...
              </h2>

              <div className="mt-6 flex flex-col items-center justify-center">
                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                <p className="mt-4 text-gray-600">
                  This might take a few seconds.
                </p>
              </div>
            </div>
          </Dialog>

          <Dialog
            open={CouponLoadTC}
            onClose={() => setCouponLoadTC(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col text-center max-h-[80vh]">
              {/* Header */}
              <div className="flex justify-between w-full items-center mb-4 border-b pb-2">
                <h2 className="text-lg font-semibold">Terms & Condition</h2>
                <button
                  className="text-2xl font-semibold"
                  onClick={() => setCouponLoadTC(false)}
                >
                  &times;
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto text-left pr-2">
                <p className="mt-2 text-gray-600">
                  <span className="font-medium">Coupon Title:</span> {CouponTC?.CouponTitle}
                  <br />
                  <span className="font-medium">Coupon Code:</span> {CouponTC?.CouponCode}
                </p>

                <p
                  className="mt-4 text-sm text-gray-700 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: CouponTC?.FareRules }}
                ></p>
              </div>
            </div>
          </Dialog>



          <Dialog
            open={isSectorModalOpen}
            onClose={() => setIsModalSector(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center text-center">

              {(() => {
                if (bookingStatus === "loading") {
                  return (
                    <>
                      <h2 className="text-lg font-semibold border-b pb-2 w-full text-center">
                        {(savetype === 2) ? 'Hold' : 'Booking'} Process...
                      </h2>
                      <div className="mt-6 flex flex-col items-center justify-center">
                        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                        <p className="mt-4 text-gray-600">
                          Please do not go back or press any button. <br />
                          This might take a few seconds.
                        </p>
                      </div>
                    </>
                  )
                } else if (bookingStatus === "success") {
                  return (
                    <>
                      <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                      {savetype === 2 ? (
                        <h2 className="text-xl font-bold text-blue-600">
                          Hold Success
                        </h2>
                      ) : (
                        <h2 className="text-xl font-bold text-green-600">
                          Booking Success
                        </h2>
                      )}

                      <p className="mt-2 text-gray-700">
                        Booking Success with booking Id-<br />
                        <span className="font-medium">{BookingData[0].BookingID}</span>. <br />
                        Have a great journey 😍
                      </p>
                      <button
                        onClick={ViewTicketDetails}
                        className="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition"
                      >
                        View Ticket Details
                      </button>
                    </>
                  )
                } else if (bookingStatus === "paymentfailed") {
                  return (
                    <>
                      <CircleX className="w-16 h-16 text-red-500 mb-4" />
                      <h2 className="text-xl font-bold text-red-600">
                        Payment Failed
                      </h2>
                      <p className="mt-2 text-gray-700">
                        {ErrorMessage}!<br />
                        <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                        {BookingData[0]?.BookingID} 😞
                      </p>
                      <button
                        onClick={() => setIsModalSector(false)}
                        className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                      >
                        Try Again
                      </button>
                    </>
                  )
                } else {
                  return (
                    <>
                      <CircleX className="w-16 h-16 text-red-500 mb-4" />
                      <h2 className="text-xl font-bold text-red-600">
                        Booking Failed
                      </h2>
                      <p className="mt-2 text-gray-700">
                        {ErrorMessage}!<br />
                        <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                        {BookingData[0].BookingID} 😞
                      </p>
                      <button
                        onClick={TryAgain}
                        className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                      >
                        Try Again
                      </button>
                    </>
                  )
                }
              })()}
            </div>
          </Dialog>



          {/* Fixed session expiry */}
          {/* <div className="fixed bottom-0 left-0 right-0 bg-black text-white text-center py-2 z-50">
            Your Session will expire in{" "}
            <span className="font-bold">{formatTime(timeLeft)}</span>
          </div> */}
        </div>
      )
      }
    </>
  );
}

// Stepper component
const Step = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-sm ${active ? "font-bold text-blue-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className={`text-sm ${active ? "text-blue-500" : "text-sm text-gray-400"}`}>{subtitle}</span>
    </div>
  </div>
);
